import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OrderEditor } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.scss']
})
export class OrderdetailsComponent implements OnInit {

  orderEditor: OrderEditor = null;
  loading: boolean = true;
  id: number = null;
  formGroup: FormGroup = new FormGroup({
    status: new FormControl('')
  });

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    const idString: string = this.activatedRoute.snapshot.paramMap.get('id');
    if (idString !== null) {
      this.id = parseInt(idString, 10);
    }
  }

  ngOnInit(): void {
    this.loadOrder();
  }

  loadOrder(): void {
    this.apiService.loadOrder(this.id).subscribe(({orderEditor}) => {
      this.orderEditor = orderEditor;
      this.formGroup.get('status').setValue(this.orderEditor.status);
    });
  }

  save(): void {
    this.apiService.updateOrder(this.id, this.formGroup.getRawValue()).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Rendelés frissítés',
        detail: 'Sikeres frissítés'
      });
      this.router.navigateByUrl('/orders');
    });
  }

}
